import $ from 'jquery';

export class DatepickerButton {
    constructor(element) {
        this.element = element;
        this.isVisible = false;
        this.element.datepickerButton = this;
        this.pickerElement = $(this.element).find('.js-datepicker-button__picker')[0];
        this.buttonToggle = $(this.element).find('.js-datepicker-button__toggle')[0];
        this.toggle(!this.element.dataset.hidden);
        this.initListeners();
    }

    hide() {
        $(this.pickerElement).hide();
        $(this.element).removeClass('active');
        this.isVisible = false;
    }

    show() {
        $(this.pickerElement).show();
        $(this.element).addClass('active');
        this.isVisible = true;
    }

    toggle(visible) {
        if (typeof visible !== 'boolean') {
            visible = !this.isVisible;
        }
        visible ? this.show() : this.hide();
    }

    initListeners() {
        this.initToggleListener();
    }

    initToggleListener() {
        $(this.buttonToggle).on('click.toggle', () => this.toggle());
    }

    destroy() {
        this.removeListeners();
    }

    removeListeners() {
        this.removeToggleListener();
    }

    removeToggleListener() {
        $(this.buttonToggle).off('click.toggle');
    }
}

const datepickerButton = $('.js-datepicker-button');
if (datepickerButton.length) {
    datepickerButton.each((i, element) => {
        new DatepickerButton(element);
    });

    document.addEventListener('click', handleClickOutside, { capture: true });

    function handleClickOutside(e) {
        $('.js-datepicker-button.active').each((i, element) => {
            if (!$(e.target).closest(element).length) {
                window.requestAnimationFrame(() => {
                    element.datepickerButton.hide();
                });
            }
        });
    }
}
